import { Component, Input, OnInit } from '@angular/core';
import { AutomataService } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-automation-name-display',
  templateUrl: './automation-name-display.component.html',
  styleUrls: ['./automation-name-display.component.scss'],
  standalone: false,
})
export class AutomationNameDisplayComponent implements OnInit {
  @Input() automationId: string;

  name$: Observable<string>;
  constructor(private readonly automataService: AutomataService) {}

  ngOnInit(): void {
    if (this.automationId) {
      this.name$ = this.automataService.getAutomation(this.automationId).pipe(
        take(1),
        map((auto) => auto.name),
      );
    }
  }
}
